import script from "./TextGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./TextGenerator.vue?vue&type=script&setup=true&lang=js"

import "./TextGenerator.vue?vue&type=style&index=0&id=0e612340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e612340"]])

export default __exports__